<template>
  <b-card no-body>
    <b-card-header>
      <h4>{{ $t('bookings.cancel_reason') }}</h4>
    </b-card-header>

    <b-card-body>
      <p v-text="reasonIdLabel" />
      <p v-text="text" />
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'CancelReason',

  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },

  computed: {
    reasonIdLabel() {
      return this.id
        ? this.$t(`enums.cancel_reasons.${this.id}`)
        : this.$t('bookings.cancel_reason_unspecified')
    },
  },
}
</script>
